<template>
    <div class="mb-5">
        <b-container fluid class="px-0">
            <!-- 질문지 명칭 및 점수산정 모드 설정 -->
            <b-row class="bgray-200 mb-5 py-4" no-gutters>
                <b-col cols="1" md="2" lg="3">
                    <div class="pl-3 pl-lg-5">
                        <b-button variant="icon" @click="$router.push({ path: '/template_list' })">
                            &lang; <span class="pl-2">목록으로</span>
                        </b-button>
                    </div>
                </b-col>
                <b-col cols="10" md="8" lg="6">
                    <div class="d-flex justify-content-center align-items-center">
                        <template v-if="is_template_meta_edit_mode">
                            <b-form-input
                                v-model="template_name"
                                type="text"
                                placeholder="질문지 템플릿 이름을 입력해주세요."
                            />

                            <b-form-select
                                v-model="template_type"
                                :options="type_options"
                                placeholder="질문지 템플릿 유형"
                                style="width: 250px"
                                class="ml-2"
                            />

                            <b-button variant="dark-border"
                                      class="ml-2"
                                      :disabled="!is_template_meta_edited || is_empty_template_meta"
                                      size="sm"
                                      @click="updateTemplate"
                            >
                                <fa icon="save"></fa>
                            </b-button>
                        </template>
                        <template v-else>
                            <h4 class="mb-0 pr-2 ">{{ template_name }}</h4>
                            <div class="ml-2 f-85">type: {{ template_type }}</div>
                        </template>

                        <b-btn variant="dark-border" class="ml-2" size="sm"
                               :disabled="(!template_type || !template_name) || is_template_edited || is_template_meta_edited"
                               @click="is_template_meta_edit_mode = !is_template_meta_edit_mode"
                        >
                            <fa icon="pen"></fa>
                        </b-btn>

                        <template v-if="is_template_meta_edit_mode">
                            <b-btn variant="outline-danger" class="ml-2" size="sm"
                                   :disabled="!is_template_meta_edited"
                                   @click="template_name = template_tree.template_name;template_type = template_tree.template_type"
                            >
                                <BIconArrowClockwise />
                            </b-btn>
                        </template>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <b-container v-if="load_error" fluid>
            <PageEmptyComponent :error="load_error" @retry="retryLoad" />
        </b-container>

        <b-container v-else fluid>
            <!-- 질문지 컨텐츠 생성 -->
            <b-row>
                <b-col cols="12" md="3">
                    <div class="d-flex justify-content-between mb-3 border-bottom border-color-gray-700 pb-2 mb-2">
                        <h5 class="mb-0">1. 질문 리스트 생성 </h5>

                        <b-btn v-show="is_question_edit_mode"
                               size="sm" variant="dark-border" class="bottom-radius-0"
                               :disabled="is_copying_template || is_empty_template_meta"
                               @click="$store.commit('update_Template_EditMode', !is_template_contents_edit_mode)"
                        >
                            <span v-show="!is_template_contents_edit_mode">
                                편집 모드
                            </span>
                            <span v-show="is_template_contents_edit_mode">
                                보기 모드
                            </span>
                        </b-btn>
                    </div>

                    <template v-if="is_template_contents_edit_mode">
                        <b-card class="mb-3" no-body>
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button v-b-toggle.collapse-copy-templates-list variant="primary" block :disabled="is_empty_template_meta">
                                    다른 질문지에서 질문 목록 가져오기
                                </b-button>
                            </b-card-header>

                            <b-collapse id="collapse-copy-templates-list" class="">
                                <b-card-body>
                                    <b-form-input
                                        v-model.trim="template_search"
                                        size="sm"
                                        class="mb-2"
                                        placeholder="질문지 이름·캠페인명으로 찾기"
                                        :disabled="is_copying_template || is_empty_template_meta"
                                    />
                                    <b-dropdown
                                        id="input-template"
                                        boundary="viewport"
                                        variant="dark-border"
                                        :class="['w-100', { 'mb-3': selected_template.template_code }, { 'mb-1': !selected_template.template_code }]"
                                        :text="selected_template.template_name"
                                        :disabled="is_copying_template || is_empty_template_meta"
                                    >
                                        <div style="max-height:45vh; overflow: auto">
                                            <b-dropdown-text v-if="!filtered_templates.length">
                                                {{ templates.length ? '검색 결과가 없습니다.' : '가져올 질문지가 없습니다.' }}
                                            </b-dropdown-text>
                                            <b-dropdown-item-button v-for="(item, idx) in filtered_templates"
                                                                    :key="`templates-template-${item.id}-idx-${idx}`"
                                                                    :disabled="is_copying_template || is_empty_template_meta"
                                                                    @click="selectTemplate(item)"
                                            >
                                                {{ idx + 1 }}. {{ item.template_name }} ({{ item.campaign_name || ' - '}})
                                            </b-dropdown-item-button>
                                        </div>
                                    </b-dropdown>
                                    <div v-show="!selected_template.template_code" class="f-85 bg-warning rounded text-center border border-dark bordr-width-2 fw-500 p-1 mb-3">
                                        복사할 질문지 템플릿을 선택해주세요
                                    </div>

                                    <div class="mb-2">
                                        <b-form-checkbox
                                            v-model="isSameQuestion"
                                            class="mt-2"
                                            :disabled="is_copying_template || is_empty_template_meta"
                                            switch
                                        >
                                            질문 목록 복사하기
                                        </b-form-checkbox>
                                    </div>
                                    <div class="mb-2">
                                        <b-form-checkbox
                                            v-model="isSameSubs"
                                            class="mt-2"
                                            :disabled="is_copying_template || !isSameQuestion || is_empty_template_meta"
                                            switch
                                        >
                                            문항 함께 가져오기
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox
                                            v-model="isNextSubs"
                                            class="mt-2"
                                            :disabled="is_copying_template || !isSameSubs || is_empty_template_meta"
                                            switch
                                        >
                                            문항 다음 버전으로 교체
                                        </b-form-checkbox>
                                    </div>


                                    <div class="bg-warning border border-dark border-width-2 text-dark rounded f-95 text-center fw-500 p-2 mt-2">
                                        <template v-if="isSameQuestion">
                                            <span v-show="!isSameSubs">
                                                질문 리스트만 복사합니다.
                                            </span>
                                            <span v-show="isSameSubs && isNextSubs">
                                                문항의 세부사항 수정이 가능합니다.
                                            </span>
                                            <span v-show="isSameSubs && !isNextSubs">
                                                문항의 세부사항을 수정할 경우, 복사한 질문지에도 반영됩니다.
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span>'질문 목록 복사하기'를 켜야 복사할 수 있습니다.</span>
                                        </template>
                                    </div>
                                </b-card-body>

                                <b-card-footer>
                                    <b-btn-group class="w-100">
                                        <b-button variant="dark" class="f-90"
                                                  :disabled="is_copying_template || is_empty_template_meta || !selected_template.template_code || !isSameQuestion"
                                                  block
                                                  @click="copyTemplateContents"
                                        >
                                            질문지 전체 복사하기
                                        </b-button>
                                        <b-button variant="primary" class="f-90 mt-0"
                                                  :disabled="is_copying_template || !selected_template.template_code"
                                                  block
                                                  @click="is_selecting_copying_questions = !is_selecting_copying_questions"
                                        >
                                            질문 선택 복사하기
                                        </b-button>
                                    </b-btn-group>

                                    <template v-if="is_copying_template">
                                        <div class="bg-danger text-light rounded px-2 py-1 mt-2">
                                            페이지를 이동하지 마시고, 완료될때까지 기다려주세요.
                                            <b-spinner v-show="is_copying_template" small class="ml-2" />
                                        </div>
                                    </template>
                                </b-card-footer>
                            </b-collapse>
                        </b-card>
                    </template>

                    <templateTree :is_template_contents_edit_mode="is_template_contents_edit_mode"/>
                </b-col>
                <b-col  cols="12" md="9" class="px-3">
                    <div class="d-flex justify-content-between border-bottom border-color-gray-700 mb-3 pb-1">
                        <h5>2. 문항별 질문 생성/편집 </h5>
                        <div class="d-flex align-items-center">
                            <b-form-checkbox v-model="is_current_question" size="md" name="check-button" switch
                                             class="mr-2"
                            >
                                <div style="margin-top: 0" class="f-90">
                                    현재 문항
                                </div>
                            </b-form-checkbox>
                            <b-overlay v-if="isIE !== true" :show="is_preparing_print" rounded spinner-small class="d-flex mr-2">
                                <print-to-pdf class="mr-2"
                                              :btn_size="'sm'"
                                              :data_prepared="print_data_fetched"
                                              :print_title="template_name"
                                              :no_answers="true"
                                              :is_current_question="is_current_question"
                                              @prepare_print_data="preparePrintData()"
                                >
                                    <fa icon="print" class="mr-1"></fa>
                                    질문지 출력
                                </print-to-pdf>
                                <print-to-pdf modal_id="pdf_down_modal_no_pipe"
                                              :btn_size="'sm'"
                                              :data_prepared="print_data_fetched_no_pipe"
                                              :no_answers="true"
                                              :view_pipe_line="false"
                                              :print_title="template_name"
                                              :is_current_question="is_current_question"
                                              @prepare_print_data="preparePrintData('no_pipe')"
                                >
                                    <fa icon="print" class="mr-1"></fa>
                                    질문지 출력 - 숨김 조건 무시
                                </print-to-pdf>
                            </b-overlay>
                            <div>
                                <b-button variant="dark-border" size="sm"
                                          :disabled="is_template_contents_edit_mode || is_copying_template || is_empty_template_meta"
                                          @click="showSubFinder"
                                >
                                    검색해서 가져오기
                                </b-button>
                            </div>
                        </div>

                    </div>
                    <QuestionMasterV2 ref="questionMaster" @modal-dirty="question_edit_dirty = $event" />
                </b-col>
            </b-row>

            <!-- <hr class="border-0 bottom-space"> -->

            <b-sidebar
                id="sidebar-sub-fider"
                :visible="show_sub_finder"
                shadow
                right
                no-header
                width="460px"
                body-class="p-3"
                @change="onSubFinderVisibleChange"
            >
                <template #default>
                    <div class="d-flex justify-content-between mb-4 pb-3 border-bottom border-color-gray-600">
                        <div>
                            <h3 class="mb-1">Subs 검색</h3>
                            <div class="f-85 text-muted">
                                <template v-if="question_composition && question_composition.question_code">
                                    대상 질문: {{ question_composition.question_name || '(이름 없음)' }} ({{ question_composition.question_code }})
                                </template>
                                <template v-else>질문을 먼저 고르세요</template>
                            </div>
                        </div>
                        <b-btn-close text-variant="dark" @click="$store.commit('update_Show_Template_SubFinder', false)" />
                    </div>
                    <sub-finder />
                </template>
            </b-sidebar>
        </b-container>

        <b-modal ref="modal-select-template-questions" v-model="is_selecting_copying_questions"
                 title="질문 목록 선택해서 질문지 템플릿 생성하기" size="xl"
                 scrollable
                 :hide-header-close="is_copying_template"
                 :no-close-on-backdrop="is_copying_template"
                 :no-close-on-esc="is_copying_template"
                 centered
        >
            <b-container>
                <b-row>
                    <b-col cols="12" md="6">
                        <b-card header="복사할 질문지 템플릿">
                            <div class="mb-2">
                                <h6>복사할 질문지 템플릿 정보</h6>
                                <ul>
                                    <li>질문지 템플릿 명: {{ selected_template.template_name }} ({{ selected_template.template_code }})</li>
                                    <li>질문지 템플릿 유형: {{ selected_template.template_type }}</li>
                                </ul>
                            </div>

                            <div>
                                <h6>복사할 질문지 템플릿 질문목록</h6>
                                <Tree
                                    :data="selected_template.template_contents"
                                    :draggable="false"
                                    :droppable="false"
                                    :preventSelect="false"
                                    :isDragPlaceHolder="false"
                                    :space="15"
                                    :indent="17.5"
                                    class="border"
                                >

                                    <template v-slot="{ data, store }">
                                        <b-list-group-item :class="`node-level-${data._vm.level}`">
                                            <div class="d-flex align-items-center justify-content-between">
                                                {{ data.question_name }}

                                                <div class="d-flex align-items-center">
                                                    <b-form-checkbox
                                                        :id="`question-${data._id}-copying-checkbox`"
                                                        v-model="selected_copying_questions"
                                                        name="question-copying-checkbox"
                                                        :value="data.question_code"
                                                        unchecked-value=""
                                                        class="mr-2 mb-0"
                                                        @change="selectCopyingQuestions"
                                                    />

                                                    <div v-if="data.children && data.children.length"
                                                         @click.stop="store.toggleOpen(data)"
                                                    >
                                                        <fa :icon="data.open ? 'angle-up' : 'angle-down'"></fa>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </template>
                                </Tree>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-card header="현재 질문지 템플릿">
                            <div class="mb-2">
                                <h6>현재 질문지 템플릿 정보</h6>
                                <ul>
                                    <li>질문지 템플릿 명: {{ template_tree.template_name }} ({{ template_tree.template_code }})</li>
                                    <li>질문지 템플릿 유형: {{ template_tree.template_type }}</li>
                                </ul>
                            </div>

                            <div>
                                <h6>생성될 질문지 목록 구조</h6>
                                <template v-if="!selected_copying_question_contents.length">
                                    좌측 "복사할 질문지 템플릿 질문목록"에서 복사할 질문지를 선택해주세요.
                                </template>
                                <template v-else>
                                    <Tree
                                        :data="selected_copying_question_contents"
                                        :draggable="false"
                                        :droppable="false"
                                        :preventSelect="false"
                                        :isDragPlaceHolder="false"
                                        :space="15"
                                        :indent="17.5"
                                        class="border"
                                    >

                                        <template v-slot="{ data, store }">
                                            <b-list-group-item :class="`node-level-${data._vm.level}`">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    {{ data.question_name }}

                                                    <div v-if="data.children && data.children.length"
                                                         class="float-right"
                                                         @click.stop="store.toggleOpen(data)"
                                                    >
                                                        <fa :icon="data.open ? 'angle-up' : 'angle-down'" class="mr-2"></fa>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                        </template>
                                    </Tree>
                                </template>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>

            <template #modal-footer>
                <div class="text-right">
                    <b-btn variant="danger" class="mr-2"
                           :disabled="(!selected_copying_questions.length || !selected_copying_question_contents.length) || is_copying_template"
                           @click="selected_copying_questions = [];selected_copying_question_contents = []"
                    >
                        초기화
                    </b-btn>
                    <b-btn variant="primary"
                           :disabled="(!selected_copying_questions.length || !selected_copying_question_contents.length) || is_copying_template || !isSameQuestion"
                           @click="copyTemplateContents"
                    >
                        <div class="d-flex align-items-center">
                            선택한 질문 구조로 복사하기
                            <b-spinner v-show="is_copying_template" class="ml-2" small />
                        </div>
                    </b-btn>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import { DraggableTree } from 'vue-draggable-nested-tree';
import cloneDeep from 'lodash/cloneDeep';
import TemplateTree from '@core_components/admin/components/templates/TemplateTree';
import SubFinder from '@core_components/admin/components/subs/SubFinder';
import PrintToPDF from '@core_components/common/PrintToPDF.vue';
import QuestionMasterV2 from '@/components/editingTemplate/QuestionMaster_v2.vue';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';
import unsavedChangesGuard from '@shared/mixin/unsaved-changes-guard';
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'EditingTemplateV2',
    mixins: [unsavedChangesGuard],
    components: {
        PageEmptyComponent,
        QuestionMasterV2,
        'print-to-pdf': PrintToPDF,
        Tree : DraggableTree,
        TemplateTree,
        SubFinder,
    },
    data () {
        return {
            type_options: [
                { value: null, text: '질문지 템플릿 유형', disabled: true },
                { value:'qesg_assessment', text:'qesg_assessment' },
                { value:'tier_zero', text:'tier_zero (저장 불가)', disabled: true }
            ],

            template_name: null,
            template_type: null,
            is_template_meta_edit_mode: false,
            is_template_edited: false,

            isSameQuestion: false,
            isSameSubs: false,
            isNextSubs: false,
            templates: [],
            is_copying_template: false,
            selected_template: {
                template_name: '질문지 템플릿 선택',
                template_code: '',
                template_contents: [],
                template_id: ''
            },

            is_selecting_copying_questions: false,
            selected_copying_questions: [],
            selected_copying_question_contents: [],
            print_data_fetched: false,
            print_data_fetched_no_pipe: false,
            is_preparing_print: false,
            template_search: '',
            is_current_question: false,
            load_error: '',
            question_edit_dirty: false,
        };
    },
    computed: {
        ...mapState(['user_id', 'company_name', 'e_mail', 'template_tree', 'is_template_edit_state', 'show_sub_finder', 'mode', 'question_composition']),
        is_question_edit_mode () {
            return this.$store.getters['questions/getter_question_edit_mode'];
        },
        is_template_contents_edit_mode () {
            return this.$store.getters.getTemplateEditStatus;
        },
        value_new () {
            return typeof this.$route.query.value_new !== 'undefined' ? this.$route.query.value_new : false;
        },

        filtered_templates () {
            const keyword = (this.template_search || '').toLowerCase();
            if (!keyword) return this.templates;
            return this.templates.filter(item => [item.template_name, item.campaign_name, item.template_code]
                .some(text => String(text || '').toLowerCase().includes(keyword)));
        },
        hasUnsavedChanges () {
            return this.is_copying_template || this.question_edit_dirty
                || (this.is_template_meta_edit_mode && this.is_template_meta_edited);
        },

        // new
        is_empty_template_meta () {
            return this.isFieldEmpty(this.template_name) || this.isFieldEmpty(this.template_type);
        },
        is_template_meta_edited () {
            return this.template_name !== this.template_tree.template_name
                || this.template_type !== this.template_tree.template_type;
        },
    },
    watch: {
        // old
        '$route.params.question_id': {
            handler (_new, _old) {
                if (_new !== _old) {
                    this.$store.commit('update_Template_EditMode', false);
                    this.$store.commit('update_Show_Template_SubFinder', false);
                    this.is_template_meta_edit_mode = false;
                    this.is_template_edited = false;
                }
            }
        },
        show_sub_finder (_status) {
            if (!_status) {
                this.$store.commit('reset_searched_subs');
            }
        },
        is_template_contents_edit_mode (_status) {
            if (_status && this.show_sub_finder) {
                this.$store.commit('update_Show_Template_SubFinder', false);
            }
        },
    },
    // 문항 수정 모달을 연 채 뒤로가기/앞으로가기로 question_id 가 바뀌면 목록이 비워져 모달이 깨진다. 먼저 묻고 닫는다.
    async beforeRouteUpdate (to, from, next) {
        const master = this.$refs.questionMaster;
        if (to.query.question_id === from.query.question_id || !master || !master.modal_mode) return next();
        if (this.question_edit_dirty && !(await master.confirmDiscard())) return next(false);
        master.hideModal();
        next();
    },
    async created () {
        if (this.value_new === true || !this.$route.query.template_id) {
            this.$store.commit('update_template_tree', null);
            this.is_template_meta_edit_mode = true;
        } else {
            await this.readTemplate(this.$route.query.template_id);
        }
        await this.readTemplateList();
    },
    beforeDestroy () {
        this.isSameQuestion = false;
        this.isSameSubs = false;
        this.templates = [];
        this.is_copying_template = false;
        this.selected_template = {
            template_name: '질문지 선택',
            template_code: '',
            template_contents: [],
            template_id: ''
        };
        this.type_options = [
            { value:'qesg_assessment', text:'qesg_assessment' },
            { value:'tier_zero', text:'tier_zero' }
        ];

        this.is_template_meta_edit_mode = false;
        this.is_template_edited = false;
        this.template_name = null;
        this.template_type = null;
        this.update_template_tree();
    },
    methods: {
        ...mapMutations(['update_template_tree', 'update_template_in_progress', 'make_template_tree']),
        retryLoad () {
            this.readTemplate(this.$route.query.template_id);
        },
        async readTemplate (template_code) {
            try {
                this.load_error = '';
                await this.$store.dispatch('readTemplateTree', { template_code, is_audit: true });

                this.template_name = this.template_tree.template_name,
                this.template_type = this.template_tree.template_type;

                this.is_template_meta_edit_mode = false;
                this.is_template_edited = false;
            } catch (error) {
                console.log(' ~ error => ', error);
                this.load_error = `질문지를 불러오지 못했습니다. (코드: ${template_code}, 사유: ${getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류')})`;
            }
        },
        async updateTemplate () {
            try {
                if (!this.template_name) return this.$EventBus.$emit('toast-warning', '질문지 저장', '템플릿 이름을 입력하여 주십시오.');
                if (!this.template_type) return this.$EventBus.$emit('toast-warning', '질문지 저장', '템플릿 type을 입력하여 주십시오.');

                await this.$store.dispatch('saveTemplateTree', {
                    // 백엔드 목록/검증 API 가 qesg_assessment 만 다루므로 유형은 고정 저장한다
                    template_type: 'qesg_assessment',
                    template_name: this.template_name,
                    template_scoring: 'manual'
                });

                // 서버가 돌려준 값을 헤더에 반영
                this.template_name = this.template_tree.template_name;
                this.template_type = this.template_tree.template_type;
                this.$router.replace({ name: this.$route.name, query: { value_new: false, template_id: this.template_tree.template_code }});
                this.is_template_meta_edit_mode = false;
                this.is_template_edited = false;
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '질문지 저장 실패', getErrorMessage(error, '질문지 저장 중 장애가 발생했습니다. 개발팀에 문의해주세요.'));
            }
        },
        selectTemplate (template) {
            this.selected_template = cloneDeep(template);
        },
        async copyTemplateContents () {
            // 중간에 실패하면 이미 만든 질문 수를 알린다(질문 목록 저장이 마지막이라 목록에는 연결되지 않는다)
            let created_count = 0;
            try {
                // 질문 목록을 복사하지 않으면 빈 배열로 현재 질문 구조 전체를 덮어쓰게 되므로 막는다
                if (!this.isSameQuestion) {
                    return this.$EventBus.$emit('toast-warning', '복사할 수 없음', "'질문 목록 복사하기'를 켠 뒤 복사해주세요.");
                }
                this.is_copying_template = true;

                let updatedContents = [];
                if (this.isSameQuestion) {
                    updatedContents = !this.is_selecting_copying_questions
                        ? JSON.parse(JSON.stringify(this.selected_template.template_contents))
                        : this.selected_copying_question_contents;

                    if (!updatedContents.length) {
                        return this.$EventBus.$emit('toast-warning', '복사할 수 없음', '빈 질문지 템플릿은 복사할 수 없습니다.');
                    }

                    const countNodes = (nodes) => (nodes || []).reduce((sum, node) => sum + 1 + countNodes(node.children), 0);
                    const current_count = countNodes(this.template_tree.template_contents);
                    const ok = await this.$showModal({
                        type: 'confirm',
                        state: 'warning',
                        title: '질문 목록 덮어쓰기',
                        message: current_count
                            ? `현재 질문 ${current_count}개가 모두 삭제되고 선택한 템플릿 '${this.selected_template.template_name}'의 질문 ${countNodes(updatedContents)}개로 교체됩니다. 저장 후에는 되돌릴 수 없습니다.`
                            : `선택한 템플릿 '${this.selected_template.template_name}'의 질문 ${countNodes(updatedContents)}개를 복사합니다. 저장 후에는 되돌릴 수 없습니다.`
                    });
                    if (!ok) return false;

                    const processContents = async (contents) => {
                        for await (let item of contents) {
                            // 문항 다음 버전 + 전체 복사인 경우, category1, category2 question도 복제
                            const check_whole_copy = (!this.is_selecting_copying_questions && this.isNextSubs) ? true :item.children.length === 0;

                            if (item.question_code && check_whole_copy) {
                                const response = await this.$axios.get('/questions', {
                                    params: { question_code: item.question_code }
                                });

                                const {
                                    question_name, question_name_e, question_name_c,
                                    question_infobox, question_infobox_e, question_infobox_c,
                                    question_contents
                                } = response.data;

                                if (!item.question_name_e) {
                                    item.question_name_e = question_name_e;
                                }

                                if (!item.question_name_c) {
                                    item.question_name_c = question_name_c;
                                }

                                item.question_code = `q${Math.floor(Math.random() * 10000000000)}`;

                                let _question = {
                                    question_code: item.question_code,
                                    question_name: question_name
                                };

                                if (question_name_e) _question['question_name_e'] = question_name_e;
                                if (question_name_c) _question['question_name_c'] = question_name_c;

                                if (item.question_infobox && item.question_infobox !== 'null') {
                                    _question['question_infobox'] = item.question_infobox;
                                }

                                if (question_infobox_e) {
                                    item.question_infobox_e = question_infobox_e;
                                    _question['question_infobox_e'] = question_infobox_e;
                                }

                                if (question_infobox_c) {
                                    item.question_infobox_c = question_infobox_c;
                                    _question['question_infobox_c'] = question_infobox_c;
                                }

                                if (question_contents.length) {
                                    if (this.isSameSubs && !this.isNextSubs) {
                                        _question['question_contents'] = question_contents;
                                    } else if (this.isSameSubs && this.isNextSubs) {
                                        let _parsed_question_contents = JSON.parse(question_contents);
                                        const _request_next_subs = _parsed_question_contents.map(sub_code => {
                                            const formData = new FormData();
                                            formData.append('sub_code', sub_code);

                                            return this.$axios.post('/subs/versioning', formData);
                                        });
                                        const _generated_next_subs = await Promise.all(_request_next_subs);
                                        const _next_question_contents = _generated_next_subs.map(({ data }) => data.sub_code);
                                        _question['question_contents'] = JSON.stringify(_next_question_contents);
                                    } else {
                                        _question['question_contents'] = '[]';
                                    }
                                }

                                _question['template_code'] = this.$route.query.template_id;
                                await this.$axios.post('/admin/questions', _question);
                                created_count++;
                            }

                            // 중첩 요소가 있는 경우 재귀 호출
                            if (item.children && item.children.length > 0) {
                                await processContents(item.children);
                            }
                        }
                    };

                    await processContents(updatedContents);
                }

                await this.$store.dispatch('saveTemplateTree', { template_contents: this.filterNestedQuestions(updatedContents) });
                this.is_selecting_copying_questions = false;
                this.$store.commit('update_Template_EditMode', !this.is_template_contents_edit_mode);
            } catch (error) {
                if (error && error.response && error.response.status === 401) return;
                this.$EventBus.$emit('toast-failure', '질문지 복사 실패',
                    getErrorMessage(error, '질문지를 복사하지 못했습니다.') + (created_count ? ` 이미 만든 질문 ${created_count}개는 질문 목록에 연결되지 않았습니다.` : ''));
            } finally {
                this.is_copying_template = false;
            }
        },
        selectCopyingQuestions () {
            this.selected_copying_question_contents = this.filterQuestionsByCodes(this.selected_template.template_contents, this.selected_copying_questions);

            this.selected_copying_question_contents.forEach(_select_question_code => {
                if (!this.selected_copying_questions.includes(_select_question_code)) {
                    this.selected_copying_questions.push(_select_question_code);
                }
            });
        },
        filterQuestionsByCodes(data, targetCodes) {
            const result = [];

            data.forEach(item => {
                const matchedChildren = this.filterQuestionsByCodes(item.children || [], targetCodes);

                const isMatched = targetCodes.includes(item.question_code);
                if (isMatched || matchedChildren.length > 0) {
                    const newItem = {
                        ...item,
                        children: isMatched ? item.children || [] : matchedChildren
                    };

                    result.push(newItem);
                }
            });

            return result;
        },
        async readTemplateList () {
            try {
                const response = await this.$axios.get('/read_template_list', {
                    params: { user_id: this.user_id, mode: 'qesg_assessment' }
                });

                let result = response.data.templates;
                this.templates = [];

                for (let item of result) {
                    item.template_contents = JSON.parse(item.template_contents);
                    this.templates.push(item);
                }
            } catch (error) {
                // 401 은 인터셉터가 로그인으로 보낸다
                if (error.response && error.response.status == '401') return;
                this.$EventBus.$emit('toast-failure', '질문지 템플릿 목록 로딩 실패', getErrorMessage(error, '복사할 질문지 목록을 불러오지 못했습니다.'));
            }
        },
        // ESC·바깥 클릭으로 닫혀도 store 를 맞춘다(아니면 다음 [검색해서 가져오기] 한 번이 헛돈다)
        onSubFinderVisibleChange (visible) {
            if (!visible && this.show_sub_finder) this.$store.commit('update_Show_Template_SubFinder', false);
        },
        showSubFinder () {
            if (!this.is_template_edit_state) {
                this.$store.commit('update_Show_Template_SubFinder');
            }
        },
        filterNestedQuestions (data) {
            if (!Array.isArray(data)) return [];

            return data.map(({ question_name, question_name_c = null, question_name_e = null, question_infobox = null, question_infobox_c = null, question_infobox_e = null, question_code, children }) => ({
                question_name, question_name_c, question_name_e,
                question_infobox, question_infobox_c, question_infobox_e,
                question_code, children: children && Array.isArray(children) ? this.filterNestedQuestions(children) : []
            }));
        },
        async preparePrintData(type = ''){
            /**
             * 질문지 출력을 위한 처리. 응답 전 연타는 무시하고, 실패하면 알린다(성공해야 PrintToPDF 가 모달을 연다).
             */
            if (this.is_preparing_print) return;
            const flag = type === 'no_pipe' ? 'print_data_fetched_no_pipe' : 'print_data_fetched';
            this[flag] = false;
            this.is_preparing_print = true;
            try {
                const {data} = await this.$axios.get(`/make_template_tree_by_template_code/${this.$route.query.template_id}`);
                this.update_template_in_progress(this.template_tree);
                this.make_template_tree(data);
                this[flag] = true;
            } catch (error) {
                if (error && error.response && error.response.status === 401) return;
                this.$EventBus.$emit('toast-failure', '질문지 출력 실패', getErrorMessage(error, '질문지 출력 데이터를 불러오지 못했습니다.'));
            } finally {
                this.is_preparing_print = false;
            }
        }
    }
};
</script>

<style lang="scss">
.node-level-1,
.node-level-2,
.node-level-3{
    font-weight: 500;
    width: 100%;
    padding: 0.25rem 0.5rem;
    border: 0;
    border-radius: 0;
}
.node-level-1{
    background-color: var(--gray-300);
}
.node-level-2{
    color: var(--gray-600);
    background-color: var(--gray-200);
}
.node-level-3{
    font-size: 0.9rem;
    color: var(--gray-600);
    background-color: var(--gray-100);
}
// .question-search-panel {
//     transition-property: width;
//     transition-timing-function: ease-in-out;
//     transition-duration: 500ms;

//     &.closed {
//         width: 0px;
//     }
// }

/* #right-side2 {
  position: relative;
  top: 0;
  right: 0;
  min-height: 100vh;
  max-height: auto;
  transition: all 0.3s;
  max-width: 300px;
  min-width: 300px;
  overflow-x: hidden;
}

#right-side2.collapsed {
  margin-right: -300px!important;
}
  
#main2 {
  min-width: 1000px;
  width: 100vw;
  height: auto;
}


*/

/* @media (max-width:1280px){
  #t-component-1{
      min-width: 200px;
  }
  #t-component-2 {
      min-width: 380px;
  }
  #right-side2 {
    min-width: 260px;
    width: auto;
  }
}
@media (max-width: 768px) {
  #right-side2 {
    min-width: 490px;
    width: auto;
  }
}
@media (max-width:736px) {
  #right-side2 {
    min-width: 97.4vw;
  }
}
@media (max-width:367px) {
  #right-side2 {
    min-width: 96vw!important;
  }
} */

</style>
